// removed by extract-text-webpack-plugin
module.exports = {"list-item":"list-item__3tDs2","active":"active__2c1o5"};


//////////////////
// WEBPACK FOOTER
// ./styles/pagination.scss
// module id = 579
// module chunks = 68